import { addDays, format, parse } from "date-fns";
const DATE_FORMAT = "dd/MM/yyyy";
const DATETIME_FORMAT = "dd/MM/yyyy h:mm a";

// Current date format Day/Month/Year e.g) 01/01/1999
// Returns null if undefined or null
export const formatDate = (date: Date | string | number | null | undefined) =>
  date != null ? format(new Date(date), DATE_FORMAT) : null;

// Display an exclusive date as inclusive
export const formatInclusiveDate = (
  date: Date | string | number | null | undefined,
) => (date != null ? formatDate(addDays(new Date(date), -1)) : null);

export const parseDate = (displayDate: string): Date => {
  return parse(displayDate, DATE_FORMAT, new Date());
};

export const formatDatetime = (date: Date | string | null | undefined) =>
  date != null ? format(new Date(date), DATETIME_FORMAT) : null;
